import React from 'react';
import PropTypes from 'prop-types';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import {
  Grid,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Chip,
  Tooltip,
} from '@mui/material';
import EditOutlined from '@mui/icons-material/EditOutlined';
import { BUTTONS, THEME_ELEMENTS, THEME_RADIUS_INDICATOR, THEME_VALUES } from 'utils/constants';

export const ThemeCard = ({
  theme,
  theme: { appliedTo: entitiesWithThisTheme, primaryColor, logoUrl, borderRadius },
  setThemeFromList,
  setEditableCommonTheme,
  closeThemeList,
}) => {
  const setTheme = () => {
    setThemeFromList(theme);
    closeThemeList();
  };

  const openCommonThemeEditor = () => {
    setEditableCommonTheme(theme);
  };

  const styledTheme = createTheme({
    palette: { primary: { main: primaryColor } },
  });

  const chosenEntitiesNames = entitiesWithThisTheme.map((entity) => {
    return <li key={entity?.id}>{entity?.business?.name || entity?.store?.name}</li>;
  });

  const isRounded = borderRadius !== THEME_VALUES.squaredRadius;
  const chipClasses = ['theme-chip', isRounded ? '' : 'square-chip'].join(' ');
  return (
    <Grid item md={4} sm={6} xs={12}>
      <Card classes={{ root: 'card-container' }}>
        <CardActionArea classes={{ root: 'card-content' }}>
          <CardMedia component="img" image={logoUrl} classes={{ root: 'card-img' }} />
          <CardContent>
            <ThemeProvider theme={styledTheme}>
              <Chip
                size="small"
                color="primary"
                classes={{
                  root: chipClasses,
                }}
                label={isRounded ? THEME_RADIUS_INDICATOR.rounded : THEME_RADIUS_INDICATOR.squared}
              />
              <Chip
                color="primary"
                size="small"
                label={THEME_ELEMENTS.primaryColorCheap}
                classes={{ root: chipClasses }}
              />
              {entitiesWithThisTheme.find((entity) => entity?.isBusinessTheme) ? (
                <Chip
                  color="primary"
                  size="small"
                  label={THEME_ELEMENTS.businessLabel}
                  classes={{ root: chipClasses }}
                />
              ) : null}
              <Tooltip title={chosenEntitiesNames} placement="right">
                <Chip
                  color="primary"
                  size="small"
                  label={THEME_ELEMENTS.storeNames}
                  classes={{ root: chipClasses }}
                />
              </Tooltip>
            </ThemeProvider>
          </CardContent>
        </CardActionArea>
        <CardActions classes={{ root: 'card-BUTTONS' }}>
          <Button
            size="small"
            classes={{ root: 'control-button' }}
            variant="contained"
            color="primary"
            onClick={setTheme}
          >
            {BUTTONS.set}
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            startIcon={<EditOutlined />}
            onClick={openCommonThemeEditor}
          >
            {BUTTONS.edit}
          </Button>
        </CardActions>
      </Card>
    </Grid>
  );
};

ThemeCard.propTypes = {
  theme: PropTypes.object.isRequired,
  setThemeFromList: PropTypes.func.isRequired,
  setEditableCommonTheme: PropTypes.func.isRequired,
  closeThemeList: PropTypes.func.isRequired,
};
